 <div class="container">
    <div class="icon">
      <!-- Warning Icon -->
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 2L1 21H23L12 2Z" stroke="#d13438" stroke-width="2"/>
        <line x1="12" y1="8" x2="12" y2="14" stroke="#d13438" stroke-width="2"/>
        <circle cx="12" cy="17" r="1.5" fill="#d13438"/>
      </svg>
    </div>

    <h1>You are not authorized to access this page for security reasons.</h1>

    <p>
      Either go back to the previous page or log in as a different user.
    </p>

    <button class="btn-primary" (click)="logout()" >
      Log in as different user
    </button>

    <!-- <a class="go-back" (click)="goBack()">
      Go back
    </a> -->
  </div>